export const PANEL_SIZE = {
  HALF: 'half size panel',
  FULL: 'full size panel',
  NONE: 'no panel',
};
